import _ from 'lodash';

class CartaPorteUbicacionesCalculator {
  data = {};

  constructor(data) {
    this.data = data;
  }

  static make(data) {
    return new CartaPorteUbicacionesCalculator(data);
  }

  get() {
    const TotalDistRec = this.getTotalDistRec();

    return { TotalDistRec };
  }

  getTotalDistRec() {
    let ubicaciones = this._getUbicaciones();

    return _.sumBy(ubicaciones, (item) => {
      return parseFloat(item.DistanciaRecorrida);
    });
  }

  _getUbicaciones(haystack = [], flag = 0) {
    return this.data.filter((item) => {
      let haystack = false;

      if (item?.DistanciaRecorrida) {
        haystack = true;
      }

      return haystack;
    });
  }
}

export default CartaPorteUbicacionesCalculator;
